module.exports = require("react-rte");